<div class="d-flex align-items-center justify-content-between w-100 flex-xl1-nowrap flex-wrap">
  <div class="d-flex flex-column gap-1 w-100">
    <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
      <h5 class="fw-semibold mb-0 text-dark">
        <span class="fw-500 text-body-tertiary">#{{ dealAddendum().seq }}.</span>
        {{ dealAddendum().builderReference.reference }}
      </h5>
      <span class="badge border fw-500 text-body-secondary border-dark-subtle p-1">
        Type:
        <span class="fw-600 text-dark ms-1">{{ dealAddendum().addendumType.name }}</span>
      </span>

      @if (dealAddendum().isCancelled) {
        <span class="badge border fw-500 fw-500 text-danger border-danger-subtle p-1"> Cancelled </span>
      }
      @if (isLocked()) {
        <span
          class="badge bg-secondary-subtle text-secondary-emphasis fw-500 d-inline-flex align-items-center gap-1 p-1"
        >
          <i class="bi bi-lock-fill"></i>
          Locked
        </span>
      }
      @if (canEditBuilderReference()) {
        <span
          class="align-items-center d-flex justify-content-center p-1 rounded-2 cursor-pointer text-body-secondary"
          role="button"
          title="Edit Builder Reference"
          (click)="openEditBuilderReferenceModal($event)"
        >
          <i class="bi bi-pencil"></i>
        </span>
      }
      <div class="d-flex gap-2 me-2 d-none">
        @if (dealAddendum().buyerApproved && dealAddendum().addendumType.name === AddendumType.INI) {
          <div class="d-flex align-items-center gap-2">
            <span class="align-items-center badge bg-success-subtle d-flex fw-500 gap-1 text-success-emphasis fs-12">
              <i class="bi bi-check-lg"></i>
              Buyer Approved
            </span>
          </div>
        }
        @if (dealAddendum().builderApproved) {
          <div class="d-flex align-items-center gap-2">
            <span class="align-items-center badge bg-success-subtle d-flex fw-500 gap-1 text-success-emphasis fs-12">
              <i class="bi bi-check-lg"></i>
              Builder Approved
            </span>
          </div>
        }
      </div>
    </div>
    <div class="d-flex gap-2 fs-14 flex-wrap mb-2">
      <span class="fw-400 me-2">
        <i class="bi bi-calendar3 me-1"></i>
        Document Date:
        <span class="fw-500 text-dark ms-2 d-inline-flex">{{ dealAddendum().documentDate | date }}</span>
      </span>
      <div class="d-flex gap-2">
        @if (dealAddendum().buyerApproved && dealAddendum().addendumType.name === AddendumType.INI && !isLocked()) {
          <div class="d-flex align-items-center gap-2">
            <span class="align-items-center badge bg-success-subtle d-flex fw-500 gap-1 text-success-emphasis fs-12">
              <i class="bi bi-check-lg"></i>
              Buyer Approved
            </span>
          </div>
        }
        @if (dealAddendum().builderApproved && !isLocked()) {
          <div class="d-flex align-items-center gap-2">
            <span class="align-items-center badge bg-success-subtle d-flex fw-500 gap-1 text-success-emphasis fs-12">
              <i class="bi bi-check-lg"></i>
              Builder Approved
            </span>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="d-flex flex-column align-items-center text-muted fs-14 gap-1">
    <span class="fw-400 fs-16 ms-xl1-auto d-flex align-items-center gap-2 me-3">
      Total:
      <span
        class="fw-500 fs-20 text-success cursor-pointer text-nowrap"
        [ngbPopover]="tooltipContent"
        placement="top"
        triggers="mouseenter:mouseleave"
        container="body"
        >{{ dealAddendum().total | currencyFormat }}</span
      >
    </span>
    <ng-template #tooltipContent>
      <div class="d-flex flex-column gap-2">
        <div class="d-flex align-items-center justify-content-between">
          <span class="me-3">Options</span>
          <span class="fw-500">{{ optionsTotal() | currencyFormat }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span>Taxes</span>
          <span class="fw-500">{{ taxesTotal() | currencyFormat }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-primary fw-500 me-3"><i class="bi bi-tag fs-14 me-2"></i>Discounts</span>
          <span class="text-primary fw-500">- {{ discountsTotal() | currencyFormat }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-primary fw-500 me-3"><i class="bi bi-gift fs-14 me-2"></i>Incentives</span>
          <span class="text-primary fw-500">- {{ incentivesTotal() | currencyFormat }}</span>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<!-- @if ((dealAddendum().builderApproved && !dealAddendum().isCancelled) || dealAddendum().isCancelled) { -->
@if (canCancel() || canDelete()) {
  <div ngbDropdown container="body" class="d-inline-flex" (click)="$event.stopPropagation()">
    <span
      class="align-items-center d-flex justify-content-center p-1 rounded-2 cursor-pointer"
      ngbDropdownToggle
      role="button"
    >
      <svg-icon [name]="'menu-dots'" class="svg-24"></svg-icon>
    </span>
    <div ngbDropdownMenu>
      @if (canCancel()) {
        <button ngbDropdownItem (click)="showConfirmation('cancel')">Cancel Addendum</button>
      }
      @if (canDelete()) {
        <button ngbDropdownItem class="text-danger" (click)="showConfirmation('delete')">Delete</button>
      }
    </div>
  </div>
}
<!-- } -->
<span
  class="align-items-center d-flex justify-content-center p-1 rounded-2 cursor-pointer"
  (click)="$event.stopPropagation(); openOptionLogsModal()"
  role="button"
>
  <i class="bi bi-info-circle"></i>
</span>

<ng-template #optionLogsPopupEl let-modal>
  <div class="modal-header">
    <h2 class="modal-title">Addendum activity logs</h2>
    <svg-icon
      [name]="'modal-close-menu'"
      class="svg-32 ms-auto"
      role="button"
      (click)="modal.dismiss('Cross click')"
    ></svg-icon>
  </div>
  <div class="modal-body">
    <addendum-logs [addendumId]="dealAddendum().id"></addendum-logs>
  </div>
</ng-template>

<ng-template #editBuilderReferencePopupEl let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3">
      <h2 class="modal-title">Edit Builder Reference</h2>
      <span role="button" class="ms-auto" (click)="modal.dismiss()">
        <svg-icon name="modal-close-menu" class="svg-32"></svg-icon>
      </span>
    </div>
    <form
      class="modal-body overflow-hidden"
      [formGroup]="builderReferenceForm"
      (ngSubmit)="saveBuilderReference(modal)"
    >
      <div class="mb-3">
        <generic-dropdown
          class="w-100"
          [items]="builderReferences()"
          [label]="'Builder Reference'"
          formControlName="builderReference"
          [allowSearch]="true"
          [clearable]="false"
          [required]="true"
          [errormessage]="'Builder Reference is required'"
          placeholder="Select Builder Reference"
        />
      </div>
    </form>
    <div class="modal-footer">
      <button
        class="btn btn-shadow"
        type="button"
        (click)="modal.dismiss()"
        [disabled]="isSubmittingBuilderReference()"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="button"
        (click)="saveBuilderReference(modal)"
        [disabled]="isSubmittingBuilderReference()"
      >
        Save
      </button>
    </div>
  </div>
</ng-template>

<p-confirmdialog />

<ng-template #tooltipContent>
  <div class="d-flex flex-column gap-2 p-2">
    <div class="d-flex justify-content-between gap-3">
      <span class="fw-500">Discounts Total:</span>
      <span>{{ discountsTotal() | currencyFormat }}</span>
    </div>
    <div class="d-flex justify-content-between gap-3">
      <span class="fw-500">Options Total:</span>
      <span>{{ optionsTotal() | currencyFormat }}</span>
    </div>
    <div class="d-flex justify-content-between gap-3">
      <span class="fw-500">Incentives Total:</span>
      <span>{{ incentivesTotal() | currencyFormat }}</span>
    </div>
    <div class="d-flex justify-content-between gap-3">
      <span class="fw-500">Taxes Total:</span>
      <span>{{ taxesTotal() | currencyFormat }}</span>
    </div>
  </div>
</ng-template>
